<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-alt"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="alert alert-info" role="alert">
            <i class="fas fa-info-circle"></i>
            หน้านี้อยู่ระหว่างการพัฒนา - ใบงาน Budget (เบิก/ปรับ/โอน)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetJob.vue